import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Cta } from 'apps/dashboard/shared/scripts/components';
import { useDeleteCard } from 'apps/shared/scripts/graphql';
import { useFormCallback } from 'apps/shared/scripts/hooks';

interface Props {
  cardId: string;
}

const DeleteCard = ({ cardId }: Props) => {
  const { mutate: deleteCard, isMutating: isDeleting } = useDeleteCard({
    refetchQueries: ['Cards'],
    awaitRefetchQueries: true,
  });
  const { isSuccess, onSuccess, onError } = useFormCallback();
  const navigate = useNavigate();

  const onDelete = useCallback(async () => {
    const confirm = window.confirm(
      'Are you sure you want to delete this card?',
    );
    if (confirm) {
      const { result, errors } = await deleteCard({ id: cardId! });
      if (!result || errors.length > 0) {
        onError(errors[0]);
      } else {
        onSuccess({ message: 'Success! Card deleted' }, () =>
          navigate('/dashboard/cards'),
        );
      }
    }
  }, [cardId, deleteCard, navigate, onError, onSuccess]);

  return (
    <Cta
      onClick={onDelete}
      loading={isDeleting}
      disabled={isDeleting}
      success={isSuccess}
      faIcon={faTrashCan}
      subtle
      mobile
    />
  );
};

DeleteCard.displayName = 'DeleteCard';

export default DeleteCard;
